<template>
  <el-dialog
    :title="`${dataForm.id ? '修改' : '新增'}配送员`"
    :close-on-click-modal="false"
    :visible.sync="visible"
    class="missionPart"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="dataRule"
      label-width="120px"
      @keyup.enter.native="dataFormSubmit()"
    >
      <div class="tablePart">
        <el-form-item label="名字" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入名字" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="dataForm.sex" filterable>
            <el-option
              v-for="(item, index) in sexOptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="dataForm.mobile" placeholder="手机号码" />
        </el-form-item>
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="dataForm.companyId" multiple clearable filterable>
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="dataForm.idCard" placeholder="身份证" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="dataForm.address" placeholder="地址" />
        </el-form-item>
        <el-form-item label="状态" size="mini" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0"> 禁用 </el-radio>
            <el-radio :label="1"> 正常 </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { dialogMixin, normal } from '@/mixins';

export default {
  mixins: [dialogMixin, normal],
  data() {
    return {
      visiblePopover: false,
      roleList: [],
      dataForm: {
        id: '',
        name: '',
        sex: '',
        mobile: '',
        companyId: '',
        idCard: '',
        address: '',
        status: '',
      },
      companyList: [],
      sexOptions: [
        { id: 0, name: '其他' },
        { id: 1, name: '男' },
        { id: 2, name: '女' },
      ],
      dataRule: {
        name: [
          {
            required: true,
            message: '名字不能为空',
            trigger: 'blur',
          },
        ],
        sex: [
          {
            required: true,
            message: '性别不能为空',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: '手机号码不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    init(id) {
      this.$init({
        url: id ? `/delivery/deliveryuser/info/${id}` : null,
        after: (data) => {
          this.dataForm = { ...data.deliveryUser };
          this.dataForm.companyId = data.deliveryUser.companyId
            ? data.deliveryUser.companyId
                .split(',')
                .map((item) => parseInt(item))
            : [];
        },
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$submit({
        before: () => {
          this.dataForm.companyId = this.dataForm.companyId
            .map((i) => i)
            .join(',');
        },
        url: `/delivery/deliveryuser/${
          !this.dataForm.id ? 'adddelivery' : 'update'
        }`,
      });
    },
    getCompanyList() {
      this.$api({
        url: `/tc/company/combo`,
        after: (data) => {
          if (data && data.code === 0) {
            this.companyList = data.list;
          }
        },
      });
    },
  },
};
</script>
<style scoped>
.mod-org {
  .org-list__input,
  .icon-list__input {
    > .el-input__inner {
      cursor: pointer;
    }
  }
  & __icon-popover {
    max-width: 350px;
  }

  & __icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }
    }
  }
  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
}
</style>
